import { render, staticRenderFns } from "./cModalOtrosEgresos.vue?vue&type=template&id=50672fb1&scoped=true"
import script from "./cModalOtrosEgresos.vue?vue&type=script&lang=js"
export * from "./cModalOtrosEgresos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50672fb1",
  null
  
)

export default component.exports